var exports = {
  "n": "xae11d333--f5821c--link",
  "Q": "xae11d333--f5821c--content",
};

module.exports = exports;
